export default "__VITE_ASSET__0yfrUrAw__"